import {cn} from '@sollapay/ui';
import {memo} from 'react';
import {useTranslation} from 'react-i18next';

export interface BuyerAssetTabsProps {
  assets: string[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

export const BuyerAssetTabs = memo<BuyerAssetTabsProps>(function BuyerAssetTabs({
  assets,
  selectedIndex,
  onSelect
}) {
  const {t} = useTranslation('trustAccounts');

  return (
    <div
      role="tablist"
      aria-label={t('view.buyers.detail.purchasedUnits')}
      className="relative flex w-fit gap-1 rounded-lg border border-border bg-background-secondary/60 p-[5px]"
    >
      {assets.map((asset, i) => (
        <button
          key={i}
          type="button"
          role="tab"
          aria-selected={i === selectedIndex}
          onClick={() => onSelect(i)}
          title={asset}
          className={cn(
            'max-w-[220px] cursor-pointer truncate rounded-md px-5 py-1.5 text-sm transition-colors',
            i === selectedIndex
              ? 'border border-border bg-background-surface font-medium text-fg shadow-xs'
              : 'text-fg-tertiary hover:text-fg'
          )}
        >
          {asset}
        </button>
      ))}
    </div>
  );
});
